<div
  class="container-fluid"
  style="margin-top: 80px"
  *ngIf="currentDisplay == 0"
>
  <div class="row">
    <mat-form-field class="col-12 col-md-6">
      <mat-label style="text-transform: uppercase">Select Semester</mat-label>
      <mat-select
        [(ngModel)]="selected_termd_id"
        (ngModelChange)="getResources()"
        disableOptionCentering
        panelClass="panelClass"
      >
        <mat-option
          style="text-transform: uppercase"
          *ngFor="let sem of studentSemesters"
          class="stym"
          [value]="sem.termd_id"
        >
          {{ sem.name }} - {{ sem.category }} - {{ sem.tag }} - {{ sem.term }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="mt-4 col-12 col-md-6">
      <input
        placeholder="Search Here.."
        [(ngModel)]="filtertext"
        class="form-control"
      />
    </div>
    <!-- <div class="mt-4 col-6 col-md-3 _watch-box"> -->
    <!-- <button mat-raised-button color="primary" (click)="watchDownloads()">Watch downloaded videos <span class="ml-2 fa fa-arrow-right"></span></button> -->
    <!-- </div> -->
  </div>
  <div class="p-3 mt-2 row">
    <div class="p-3 mt-5 col-12" *ngIf="loading == true">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div
      class="p-3 mt-5 bg-white rounded shadow col-12"
      *ngIf="courseArr.length == 0 && loading == false"
    >
      <h5 class="text-center">
        You currently do not have any course/resource to view for this semester,
        kindly check to ensure that you have registered for the courses.
      </h5>
    </div>
    <div class="col-12" *ngIf="loading == false">
      <div class="row">
        <div
          class="p-2 mt-3 col-12 col-md-3"
          *ngFor="let i = index; let course; of: courseArr"
        >
          <div class="p-2 shadow-sm card card-body _card-body">
            <h6 style="font-size: 10pt">{{ course.title | uppercase }}</h6>
            <p style="font-size: 9pt" class="text-muted">
              {{ course.s_desc | uppercase }}
            </p>
            <!-- <p class="f-desc">{{course.f_desc}}</p>     -->
            <hr />
            <p>
              <small class="text-muted">
                <mat-icon
                  style="font-size: 10pt; margin-right: -10px; margin-top: -2px"
                  >topic</mat-icon
                >
                {{ course.topics.length }}
                {{ course.topics.length > 1 ? "topics" : "topic" }}</small
              >
              <button
                mat-raised-button
                color="primary"
                class="float-right"
                (click)="openCourse(course)"
              >
                Open
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="mt-2 row" *ngFor = "let r of resources">
    <div class="col-md-12">
        <h3>{{ r.resource_type }}</h3>
    </div>
    <div class="col-md-12 faint-text" *ngIf="r.resources.length == 0"><i>No resource in this category</i></div>
        <div *ngFor="let i of r.resources | resourceFilter : filtertext" class="mb-3 col-md-3">
            <div class="shadow card" *ngIf="r.resource_type == 'Videos'">
                <mat-video [keyboard] = "false" #video src="{{ i.path }}"></mat-video>
                <div class="card-body _card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12">
                                <div class="text-wrapper">
                                    <h6 class="card-title" title="{{i.title + ' - ' + i.resource}}">{{i.title + " - " + i.resource}} </h6>
                                    <span class="faint-text">Uploaded on: {{i.created_at}}</span><br />
                                    <span class="faint-text">Uploaded by: {{i.author}}</span>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="shadow card" *ngIf="r.resource_type == 'Documents'">
                    <div class="card-body">
                        <div class="text-wrapper">
                            <h6 class="card-title"  title="{{i.title + ' - ' + i.resource}}">{{i.title + " - " + i.resource}}</h6>
                            <span class="faint-text">Uploaded on: {{i.created_at}}</span><br />
                            <span class="faint-text">Uploaded by: {{i.author}}</span><br /><br />
                            <a mat-raised-button title="Download" href="{{i.path}}" download><i class="material-icons">get_app</i></a>
                        </div>
                       
                    </div>
            </div>
            
        </div>
    </div> -->
</div>

<div
  class="container-fluid"
  style="margin-top: 70px"
  *ngIf="currentDisplay == 1"
>
  <div class="mt-4 row">
    <!-- Video play on mobile screen -->
    <div class="col-12">
      <div class="row d-block d-md-none">
        <div class="pl-3 col-12">
          <!-- <p style="font-size: 10pt" class="text-muted">{{currentTopic | uppercase}} > {{currentResource.resource | uppercase}}</p> -->
          <h6>
            <small style="font-size: 8pt"
              >{{ currentTopic | uppercase }} ></small
            >
            {{ currentResource.resource | uppercase }}
          </h6>
          <p class="text-muted" style="font-size: 8pt">
            <span>
              <strong>Author:</strong> {{ currentResource.author }} <br />
              <strong>Uploaded On:</strong> {{ currentResource.created_at }}
            </span>
          </p>
          <iframe
            *ngIf="
              currentResource.resource_type_id == 3 ||
              currentResource.resource_type_id == 1
            "
            [src]="sanitize(currentResource.path)"
            width="100%"
            height="600"
            title="{{ currentResource.resource }}"
          ></iframe>
          <!-- <embed
            [src]="sanitize(currentResource.path)"
            width="100%"
            height="600"
            *ngIf="currentResource.resource_type_id == 1"
          /> -->
          <video
            #videoElement
            *ngIf="currentResource.resource_type_id == 2"
            (contextmenu)="onRightClick($event)"
            controls
            width="100%"
            height="70%"
            [src]="currentResource.path"
            style="margin-top: -10px"
            id="forVideo"
            controlsList="{{ controlListVar }}"
          >
            Your browser does not support HTML 5 videos
          </video>
          <div class="row">
            <div class="col-10">
              <button class="mt-2 back-btn btn-muted" (click)="backToCourse()">
                <i class="icon-chevron-left"></i> Back to Course
              </button>
            </div>
            <div class="col-2">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Example icon-button with a menu"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="viewNote()">
                  <mat-icon>notes</mat-icon>
                  <span>Note</span>
                </button>
                <button mat-menu-item (click)="viewQuestionsAnswer()">
                  <mat-icon>quiz</mat-icon>
                  <span>Q & A</span>
                </button>
                <button mat-menu-item (click)="viewSubResources()">
                  <mat-icon>folder_open</mat-icon>
                  <span>Sub-Resources</span>
                </button>
                <button mat-menu-item (click)="viewAnnouncements()">
                  <mat-icon>campaign</mat-icon>
                  <span>Announcements</span>
                </button>
              </mat-menu>
            </div>
          </div>
          <!-- <embed [src]="{{sanitize(currentResource.path)}}" width="800px" height="2100px" *ngIf="currentResource.resource_type_id == 1"/> -->

          <!-- <a [href]="currentResource.path" class="float-right mt-3" [download]="currentResource.downloadURL">
                        <button mat-raised-button color="primary">Download <span class="fa fa-download"></span></button>
                    </a> -->
          <!-- <div class="clearfix"></div> -->
        </div>
      </div>

      <!-- Topics and resources menu mobile screen-->
      <div class="mt-1 row d-block d-md-none">
        <div class="pl-4 pr-4 col-md-4 topic-list-mobile">
          <h5 class="mt-2">
            {{ currentCourse.title | uppercase }} -
            {{ currentCourse.s_desc | uppercase }}
          </h5>
          <hr style="margin-bottom: -10px !important" />
          <mat-accordion class="col-12" *ngIf="topicArr.length > 0">
            <mat-expansion-panel
              [expanded]="topic.topic_id == topicArr[0].topic_id"
              *ngFor="let topic of topicArr"
              class="mb-2"
              style="box-shadow: none !important"
            >
              <mat-expansion-panel-header
                class="mb-1"
                style="background-color: #eee"
              >
                <mat-panel-title>
                  <small class="text-muted" style="font-size: 8pt !important">{{
                    topic.topic | uppercase
                  }}</small>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div
                class="bg-white row"
                style="width: 118%; margin-left: -9%"
                *ngFor="let resource of topic.resources"
              >
                <div
                  class="p-2 pt-3 pb-3 resource col-12"
                  (click)="openResource(resource, topic.topic)"
                  [class.active]="resource.resource_id == currentResourceId"
                >
                  <mat-icon *ngIf="resource.resource_type_id == 3"
                    >link</mat-icon
                  >
                  <mat-icon *ngIf="resource.resource_type_id == 2"
                    >play_circle_outline</mat-icon
                  >
                  <mat-icon *ngIf="resource.resource_type_id == 1"
                    >text_snippet</mat-icon
                  >
                  <span
                    style="display: inline-block; margin-top: -50px !important"
                  >
                    {{ resource.resource }}
                  </span>
                </div>
              </div>
              <p *ngIf="topicArr.length == 0">No Resource found</p>
            </mat-expansion-panel>
          </mat-accordion>
          <div
            class="p-2 pt-3 pb-3 resource col-12"
            *ngIf="topicArr.length == 0"
          >
            <p>No topic/resource found for this course</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Topics and resources menu desktop screen-->
    <div
      class="pl-4 pr-4 col-md-4 topic-list d-none d-md-block"
      style="border-right: 1px solid grey; max-height: 88vh; overflow: auto"
    >
      <button class="back-btn btn-muted" (click)="backToCourse()">
        <i class="icon-chevron-left"></i> Back to Course
      </button>
      <h5 class="mt-2">
        {{ currentCourse.title | uppercase }} -
        {{ currentCourse.s_desc | uppercase }}
      </h5>
      <hr style="margin-bottom: -10px !important" />
      <mat-accordion class="col-12" *ngIf="topicArr.length > 0">
        <mat-expansion-panel
          [expanded]="topic.topic_id == topicArr[0].topic_id"
          *ngFor="let topic of topicArr"
          class="mb-2"
          style="box-shadow: none !important"
        >
          <mat-expansion-panel-header
            class="mb-1"
            style="background-color: #eee"
          >
            <mat-panel-title>
              <small class="text-muted" style="font-size: 8pt !important">{{
                topic.topic | uppercase
              }}</small>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div
            class="bg-white row"
            style="width: 118%; margin-left: -9%"
            *ngFor="let resource of topic.resources"
          >
            <div
              class="p-2 pt-3 pb-3 resource col-12"
              (click)="openResource(resource, topic.topic)"
              [class.active]="resource.resource_id == currentResourceId"
            >
              <mat-icon *ngIf="resource.resource_type_id == 3">link</mat-icon>
              <mat-icon *ngIf="resource.resource_type_id == 2"
                >play_circle_outline</mat-icon
              >
              <mat-icon *ngIf="resource.resource_type_id == 1"
                >text_snippet</mat-icon
              >
              <span style="display: inline-block; margin-top: -50px !important">
                {{ resource.resource }}
              </span>
            </div>
          </div>
          <p *ngIf="topicArr.length == 0">No Resource found</p>
        </mat-expansion-panel>
      </mat-accordion>
      <div class="p-2 pt-3 pb-3 resource col-12" *ngIf="topicArr.length == 0">
        <p>No topic/resource found for this course</p>
      </div>
    </div>

    <!-- Video play on desktop screen -->
    <div
      class="pl-3 col-8 d-none d-md-block"
      style="max-height: 87vh; overflow: auto"
    >
      <!-- <p style="font-size: 10pt" class="text-muted">{{currentTopic | uppercase}} > {{currentResource.resource | uppercase}}</p> -->
      <h4>
        <small style="font-size: 8pt">{{ currentTopic | uppercase }} ></small>
        {{ currentResource.resource | uppercase }}
      </h4>
      <p class="text-muted" style="font-size: 8pt">
        <span>
          <strong>Author:</strong> {{ currentResource.author }} <br />
          <strong>Uploaded On:</strong> {{ currentResource.created_at }}
        </span>
      </p>
      <iframe
        *ngIf="currentResource.resource_type_id == 3"
        [src]="sanitize(currentResource.path)"
        width="100%"
        height="70%"
        title="{{ currentResource.resource }}"
      ></iframe>
      <!-- <object width="100%" height="80%" type="application/pdf" data="[{{sanitize(currentResource.path)}}]#zoom=85&scrollbar=0&toolbar=0&navpanes=0" id="pdf_content" style="pointer-events: none;">
                <p>Insert your error message here, if the PDF cannot be displayed.</p>
            </object> -->
      <embed
        [src]="sanitize(currentResource.path)"
        width="100%"
        height="80%"
        *ngIf="currentResource.resource_type_id == 1"
      />

      <a
        [href]="currentResource.path"
        target="_blank"
        class=""
        *ngIf="currentResource.resource_type_id == 3"
      >
        <button mat-raised-button color="primary">Open Link in New Tab</button>
      </a>
      <video
        id="forVideo"
        *ngIf="currentResource.resource_type_id == 2"
        (contextmenu)="onRightClick($event)"
        controls
        width="100%"
        height="70%"
        [src]="currentResource.path"
        style="margin-top: -10px"
        controlsList="{{ controlListVar }}"
      >
        Your browser does not support HTML 5 videos
      </video>
      <div>
        <mat-tab-group (selectedIndexChange)="update($event)">
          <mat-tab label="Notes">
            <app-desktop-resources-note></app-desktop-resources-note>
          </mat-tab>
          <mat-tab label="Q&A">
            <app-desktop-resources-questions></app-desktop-resources-questions>
          </mat-tab>
          <mat-tab label="Sub-Resources">
            <app-desktop-sub-resources></app-desktop-sub-resources>
          </mat-tab>
          <mat-tab label="Announcements">
            <app-desktop-announcement></app-desktop-announcement>
          </mat-tab>
        </mat-tab-group>
      </div>
      <!-- <button type="button"
                    fileSaver
                    [method]="'GET'"
                    [fileName]="currentResource.downloadName"
                    [url]="currentCourse.path"
                    (success)="onSuc($event)"
            >Download Video</button> -->
      <!-- <a [href]="'#'" [download]="currentResource.my_key" cl>
                <button (click)="onSave()" class="float-right" type="button" color="primary" mat-raised-button>Download Video</button>
            </a> -->
      <!-- <a [href]="'#'" [download]="currentResource.my_key" cl> -->
      <!-- <button (click)="onSave()" class="float-right" type="button" color="primary" mat-raised-button>Download Video</button> -->
      <!-- </a> -->
    </div>
  </div>
</div>
